import React from 'react';
import Avatar from '../common/Avatar';

export default function DoctorSummaryCard({ doctor }) {
  if (!doctor) return <div className="skeleton" style={{ height: 104 }} />;
  return (
    <div className="card card--pad doctor-summary">
      <Avatar name={doctor.name} src={doctor.photoUrl} size="md" />
      <div className="u-grow">
        <p className="doctor-summary__name">{doctor.name}</p>
        <p className="doctor-summary__meta">
          {doctor.specialty}
          {doctor.qualifications ? ` · ${doctor.qualifications}` : ''}
        </p>
        <p className="doctor-summary__meta">{doctor.languages?.join(', ')}</p>
      </div>
    </div>
  );
}
